<template>
    <div>
        <template v-if="bill_payments === true && title != ''">

            <!-- In future payment engine here -->

            <virtualAccountComponent v-if="$global.user_vr_corp == 'YES'" :paymentType="'bill_payment'" :billIds="bill_id"></virtualAccountComponent>

            <fincaComponent v-else-if="paymentEngine == 'FINCA' " :paymentType="'bill_payment'" :billIds="bill_id"></fincaComponent>
            <meezanComponent v-else-if="paymentEngine == 'MEEZAN' " :paymentType="'bill_payment'" :billIds="bill_id" :meezan_balance="meezan_balance"></meezanComponent>

            <!--Sent to Checker Modal -->
            <div class="modal fade" id="sendToChecker" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body send-to-checker-popup text-center p-4">
                            <span class="exclamation-outer">
                                <i class="fas fa-exclamation"></i>
                            </span>
                            <h2 class="mt-4 mb-3"> Wait! Are you sure everything is correct? </h2>
                            <button type="button" class="btn btn-primary submit_form " @click="sendToChecker">Yes</button>
                            <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close" > No</button>
                        </div>
                    </div>
                </div>
            </div>

            <!--Sent to Approver Modal -->
            <div class="modal fade" id="sendToApprover" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body send-to-checker-popup text-center p-4">
                            <span class="exclamation-outer">
                                <i class="fas fa-exclamation"></i>
                            </span>
                            <h2 class="mt-4 mb-3"> Wait! Are you sure everything is correct?  </h2>
                            <button type="button" class="btn btn-primary sendtoapprover" @click="sendToApprover">Yes</button>
                            <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close" >No</button>
                        </div>
                    </div>
                </div>
            </div>

            <!--Reject Batch-->
            <div class="modal fade" id="rejectBill" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-body send-to-checker-popup text-center p-4">
                            <span class="exclamation-outer">
                                <i class="fas fa-exclamation"></i>
                            </span>
                            <h2 class="mt-4 mb-3"> Do you really want to reject this?  </h2>
                            <button type="button" class="btn btn-primary delete" @click="rejectBill">Yes</button>
                            <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close" >No</button>
                        </div>
                    </div>
                </div>
            </div>

            <!--Second Approver-->
            <div class="modal fade" id="sendToSecondApproverPopup" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body send-to-checker-popup text-center p-4">
                            <span class="exclamation-outer">
                                <i class="fas fa-exclamation"></i>
                            </span>
                            <h2 class="mt-4 mb-3"> Wait! Are you sure everything is correct? </h2>
                            <button type="button" class="btn btn-primary sendtosecondapprover" @click="sendtosecondapprover()">Yes</button>
                            <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close">No</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="batch-history mb-3 clearfix" v-if="batchHistory.length > 0">
                <h2> <span class="text"> Batch History </span> </h2>
                <ul class="batch-status-list">
                    <li class="status-list-item" v-for="bh in batchHistory" :key="bh.id">
                        <span class="status uploaded" v-if="bh.action == 'MAKER'"> Created
                            <!-- Show Flagged Comment -->
                            <div class="dropdown-menu reupload-dropdown flagged-message dropdown-menu-right">
                                <div class="dropdown-content">
                                    <div class="flag"> <img src="/images/flag.png'" alt="" /> </div>
                                    <div class="user-section mb-3">
                                        <span class="user-image">
                                            <img class="user-image" :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                                        </span>
                                        <p class="">
                                            <span class="user-status user-name">{{bh.user.name}}</span>
                                            <span class="user-status date">{{bh.created_at | date_format}}</span>
                                        </p>
                                    </div>
                                    <div class="text">
                                        <p> {{bh.comment}} </p>
                                    </div>
                                </div>
                            </div>
                        </span>
                        <span class="status flagged" v-if="bh.action == 'CHECKER'"> Checked
                            <!-- Show Reuploaded Comment -->
                            <div class="dropdown-menu reupload-dropdown flagged-message dropdown-menu-right">
                                <div class="dropdown-content">
                                    <div class="flag"> <img src="'/images/flag.png'" alt="" /> </div>
                                    <div class="user-section mb-3">
                                        <span class="user-image">
                                            <img class="user-image" :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                                        </span>
                                        <p class="">
                                            <span class="user-status user-name">{{bh.user.name}}</span>
                                            <span class="user-status date">{{bh.updated_at | date_format}}</span>
                                        </p>
                                    </div>
                                    <div class="text">
                                        <p> {{bh.comment}} </p>
                                    </div>
                                </div>
                            </div>
                        </span>
                        <span class="status completed" v-if="bh.action == 'APPROVER'"> Approved
                            <!-- Show Disapprove Comment -->
                            <div class="dropdown-menu reupload-dropdown flagged-message dropdown-menu-right">
                                <div class="dropdown-content">
                                    <div class="flag"> <img src="'/images/flag.png'" alt="" /> </div>
                                    <div class="user-section mb-3">
                                        <span class="user-image">
                                            <img class="user-image" :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                                        </span>
                                        <p class="">
                                            <span class="user-status user-name">{{bh.user.name}}</span>
                                            <span class="user-status date">{{bh.updated_at | date_format}}</span>
                                        </p>
                                    </div>
                                    <div class="text">
                                        <p> {{bh.comment}} </p>
                                    </div>
                                </div>
                            </div>
                        </span>
                    </li>
                </ul>
            </div>

            <div class="batch-process-history mb-3">
                <div class="batch-process-outer" v-for="bh in batchHistory" :key="bh.id" v-if="['APPROVER','CHECKER','MAKER'].includes(bh.action)">
                    <div class="batch-process-inner created-by"  v-if="bh.action == 'MAKER'">
                        <span class="action-by"> Created By </span>
                        <div class="process-content">
                            <div class="user">
                                <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                            </div>
                            <p class="batch-process-text">
                                <strong class="title" :title="bh.username"> {{ bh.user.name }} </strong>
                            </p>
                        </div>
                        <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                    </div>
                    <div class="batch-process-inner flagged-by" v-if="bh.action == 'CHECKER'">
                        <span class="action-by"> Checked By </span>
                        <div class="process-content">
                            <div class="user">
                                <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                            </div>
                            <p class="batch-process-text">
                                <strong class="title" :title="bh.username"> {{ bh.user.name }} </strong>
                            </p>
                        </div>
                        <div class="created-date text-right"> {{ bh.updated_at | date_format }} </div>
                    </div>
                    <div class="batch-process-inner approved-by" v-if="bh.action == 'APPROVER'">
                        <span class="action-by"> Approved By </span>
                        <div class="process-content">
                            <div class="user">
                                <img :src="'/avatar/'+bh.image" @error="$event.target.src = '/images/table-dummy-image.jpg'"/>
                            </div>
                            <p class="batch-process-text">
                                <strong class="title" :title="bh.username"> {{ bh.user.name }} </strong>
                            </p>
                        </div>
                        <div class="created-date text-right"> {{ bh.updated_at | date_format }} </div>
                    </div>
                </div>
            </div>

            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="mt-0"> View Bill Payment </h1>
                <template v-if="process_bill == true">
                    <button v-if="process_bill == true && status != 'PAID' && status != 'REJECT' && this.$global.user_vr_corp == 'YES' && this.$global.user_vr_balance >= this.amountBill && no_of_approver == 1 && this.amountBill > 0" class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#loginMoblizer"> Process </button>
                    <button v-if="process_bill == true && status != 'PAID' && status != 'REJECT' && this.$global.user_vr_corp == 'NO' && no_of_approver == 1 && this.corporateAccountBalance >= this.amountBill && this.amountBill > 0" class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#loginMoblizer"> Process </button>
                    <button class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#sendToSecondApproverPopup" v-else-if=" this.process_bill == true && no_of_approver > 1 && status != 'PAID' && status != 'REJECT'"> Send to {{this.$global.nextApprover}} </button>

                </template>
                <template v-else-if="bill_send_to_checker == true && status == 'MAKER' && status != 'PAID'">
                    <a href="#" class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#sendToChecker" v-if="this.bill_send_to_checker == true && status == 'MAKER' && status != 'PAID'"> Send To 
                        <template v-if="this.$global.nextMaker == ''">Checker</template>
                        <template v-else>{{this.$global.nextMaker}}</template>
                    </a>
                </template>
                <template v-else-if="bill_send_to_approver == true && status != 'PAID' && (status == 'CHECKER' || status == 'MAKER') ">
                    <a href="#" class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#sendToApprover" v-if="this.bill_send_to_approver == true && status != 'PAID'  && (status == 'CHECKER' || status == 'MAKER')"> Send To
                        <template v-if="this.$global.nextChecker == ''">Approver</template>
                        <template v-else>{{this.$global.nextChecker}}</template>
                    </a>
                </template>
                
                
                <!-- <button v-if="bill_send_to_checker == true && status == 'MAKER' && status != 'PAID'" class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#sendToChecker"> Send To Checker </button>
                <button v-if="bill_send_to_approver == true && status == 'CHECKER' && status != 'PAID'" class="btn btn-primary float-right mr-1" data-toggle="modal"  data-target="#sendToApprover"> Send To Approver </button>
                <button v-if="process_bill == true && status != 'PAID' && status != 'REJECT'" class="btn btn-primary float-right mr-1" data-toggle="modal" data-target="#loginMoblizer"> Process </button> -->
                <button v-if="process_bill == true && status != 'PAID' && status != 'REJECT'" class="btn btn-primary float-right mr-1"  data-toggle="modal" data-target="#rejectBill"> Reject Batch </button>
            </div>
                <div v-if="(this.$global.user_vr_corp == 'YES' && display == true ) && process_bill == true && status != 'PAID' && status != 'REJECT' && this.amountBill >= this.$global.user_vr_balance" class="alert alert-danger" role="alert">
                <p class="pl-2 pr-2"><b> Warning! </b> Your account has insufficient balance for this batch to process. Current Balance : {{this.$global.user_vr_balance}}</p>
                </div>
                <div v-if="(this.$global.user_vr_corp == 'NO' && display == true ) && process_bill == true && status != 'PAID' && status != 'REJECT' && this.amountBill >= this.corporateAccountBalance" class="alert alert-danger" role="alert">
                <p class="pl-2 pr-2"><b> Warning! </b> Your account has insufficient balance for this batch to process. Current Balance : {{this.corporateAccountBalance}}</p>
                </div>
            <div class="bill-payments-main">
                
                <div class="view-bill-payment">
                    <div class="row">
                        <div class="col-md-8"> <p class="title"> Title </p> </div>
                        <div class="col-md-4"> <p> {{title}} </p> </div>
                    </div>
                    <div class="row">
                        <div class="col-md-8"> <p class="title"> Comment </p> </div>
                        <div class="col-md-4"> <p> 	{{reason}} </p> </div>
                    </div>
                    <div class="row">
                        <div class="col-md-8"> <p class="title"> Bill Company </p> </div>
                        <div class="col-md-4"> <p> {{categoryName}} </p> </div>
                    </div>
                    <div class="row">
                        <div class="col-md-8"> <p class="title"> Companies </p> </div>
                        <div class="col-md-4"> <p> {{billerCodeName}} </p> </div>
                    </div>
                    <div class="row">
                        <div class="col-md-8"> <p class="title"> Reference / Consumer No. </p> </div>
                        <div class="col-md-4"> <p> {{referenceNo}} </p> </div>
                    </div>
                    <div class="row">
                        <div class="col-md-8"> <p class="title"> Consumer Title </p> </div>
                        <div class="col-md-4"> <p> {{consumerTitle}} </p> </div>
                    </div>
                    <div class="row">
                        <div class="col-md-8"> <p class="title"> Amount </p> </div>
                        <div class="col-md-4"> <p> {{amountBill}} </p> </div>
                    </div>
                    <div class="row">
                        <div class="col-md-8"> <p class="title"> Due Date. </p> </div>
                        <div class="col-md-4"> <p> {{dueDate | Day_month_first_format}} </p> </div>
                    </div>
                    <div v-if="transactionCode != ''" class="row">
                        <div class="col-md-8"> <p class="title"> Transaction ID </p> </div>
                        <div class="col-md-4"> <p> {{transactionCode}} </p> </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="bill_payments === null"><preLoader></preLoader></template>
        <template v-else-if="bill_payments === false"><notAllowed></notAllowed></template>
	</div>
</template>
<script>
    import fincaComponent from '../modals/fincaComponent';
    import meezanComponent from '../modals/meezanComponent';
    import virtualAccountComponent from '../modals/virtualAccountComponent';
    export default {
        components: {
            fincaComponent,
            meezanComponent,
            virtualAccountComponent
        },
         data() {
            return {
                display : false,
                title :'',
                reason :'',
                categoryName :'',
                billerCodeName :'',
                referenceNo :'',
                consumerTitle :'',
                amountBill :'',
                dueDate:'',
                process_bill: '',
                bill_payments: '',
                bill_send_to_checker: '',
                bill_send_to_approver: '',
                paymentEngine: '',
                bill_id:'',
                transactionCode:'',

                no_of_maker:null,
                no_of_checker:null,
                no_of_approver:null,
                corporateAccountBalance: null,
                meezan_balance : '',
                batchHistory: null,
            };
        },
        mounted() {
            this.$Progress.start();
            this.can('process_bill|bill_send_to_checker|bill_send_to_approver|bill_payments').then(result => {
                this.bill_payments = result.bill_payments;
                this.bill_send_to_checker = result.bill_send_to_checker;
                this.bill_send_to_approver = result.bill_send_to_approver;
                this.process_bill = result.process_bill;
            }).then(result => {
                if(this.bill_payments == true){
                    this.getCorporateCompanyBalance();
                    this.viewBillPayment();
                    this.getPaymentEngineData();
                }else{
                    this.$Progress.finish();
                }
            });
        },
        methods: {
            getCorporateCompanyBalance: function(){
                axios.get("/api/getCurrentBalanceData")
                .then(res => {
                    if(res.status == 200){
                        this.corporateAccountBalance = res.data.data.balance;
                    }else{
                        this.showAlertBox('error','Error to fetch balance!');
                    }
                })
                .catch(err => {
                    this.showAlertBox('error','Error to fetch balance!');
                });
            },
            viewBillPayment: function(){
                axios.get('/api/viewBillPayment/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        //for meezan case
                        this.meezan_balance = res.data.meezan_balance;
                        this.paymentEngine = res.data.payment_engine;
                        this.account_status = res.data.account_status;
                        if(this.account_status !== '' || this.account_status !== null){
                            if(this.account_status.status == 400){
                                this.account_msg = this.account_status.msg;
                            }
                        }
                        this.display = true;
                        this.bill_id = res.data.bill.id;
                        this.title = res.data.bill.title;
                        this.reason = res.data.bill.reason;
                        this.categoryName = res.data.bill.categoryName;
                        this.reason = res.data.bill.reason;
                        this.consumerTitle=res.data.bill.consumerTitle;
                        this.referenceNo = res.data.bill.referenceNo;
                        this.amountBill = res.data.bill.amountBill;
                        this.billerCodeName = res.data.bill.billerCodeName;
                        this.status = res.data.bill.status;
                        this.dueDate = res.data.bill.dueDate;
                        this.transactionCode = res.data.bill.transactionCode;

                        this.no_of_maker = res.data.bill.no_of_maker;
                        this.no_of_checker = res.data.bill.no_of_maker;
                        this.no_of_approver = res.data.bill.no_of_approver;
                        this.batchHistory = res.data.bill.history;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    }
                }).catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load form data');
                });
            },
            getPaymentEngineData: function(){
                this.$Progress.start();
                axios.post("/api/getPaymentEngine")
                    .then(res => {
                        if(res.status == 200){
                            this.paymentEngine = res.data.data;
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Error to load form data');
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    });
            },
            sendToChecker: function(){
                this.$Progress.start();
                $('#sendToChecker').modal('hide');
                axios.post("/api/billSendToChecker",{
                    billId: this.$route.params.id
                })
                    .then(res => {
                        if(res.data.code == 200){
                            this.$Progress.finish();
                            if(this.$global.nextMaker == ''){
                                this.showToastBox('success','Bill successfully sent to checker');
                            }else{
                                this.showToastBox('success','Bill successfully sent to '+this.$global.nextMaker);
                            }
                            this.$router.push('/billPayments');
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Error to load form data');
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    });
            },
            sendToApprover: function(){
                this.$Progress.start();
                $('#sendToApprover').modal('hide');
                axios.post("/api/billSendToApprover",{
                    billId: this.$route.params.id
                })
                    .then(res => {
                        if(res.data.code == 200){
                            this.$Progress.finish();
                            if(this.$global.nextChecker == ''){
                                this.showToastBox('success','Bill successfully sent to approver');
                            }else{
                                this.showToastBox('success','Bill successfully sent to '+this.$global.nextChecker);
                            }
                            this.$router.push('/billPayments');
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Error to load form data');
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    });
            },

            sendtosecondapprover: function(){
                this.$Progress.start();
                $('#sendToSecondApproverPopup').modal('hide');
                axios.get('/api/billSendToSecondApprover/'+this.$route.params.id, {})
                    .then(res => {
                        if(res.data.code == 200){
                            this.showToastBox('success','Bill is Approved successfully');
                            this.$router.push('/billPayments');
                        }else{
                             this.$Progress.fail();
                            this.showAlertBox('error','Error to load form data');
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    });
            },
            rejectBill: function(){
                this.$Progress.start();
                $('#rejectBill').modal('hide');
                axios.get("/api/rejectBillPayment/"+this.$route.params.id)
                    .then(res => {
                        if(res.data.status == 200){
                            this.showToastBox('success','Bill is rejected successfully');
                            this.$router.push('/billPayments');
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Error to load form data');
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    });
            },
            created() {
                //
            }
        }
    }
</script>
